import { Store } from "vuex";
import { getSocket } from "@/utils/socket";
import { joinRoom } from "@/utils/socket-rooms";
import { SocketChannels } from "@/utils/enums";
import { PUSH_NOTIFICATION_POPUP_ACTION } from "@/store/action-types";
import { SOCKET_BOUND } from "@/store/mutation-types";

/**
 * Binds socket.io notification listeners and joins user/org rooms.
 * Call once after the store is initialized and the user is authenticated.
 */
export function bindNotificationSocket(store: Store<any>): void {
  const state = store.state.notification;
  if (state.socketBound) return;

  const socket = getSocket();

  const joinRooms = () => {
    const account = store.state.account?.account?.data;
    if (!account) return;

    if (account.id && socket.connected) {
      joinRoom(socket, `user:${account.id}`);
    }

    if (account.organizationId && socket.connected) {
      joinRoom(socket, `org:${account.organizationId}`);
    }
  };

  // Remove any existing listeners to avoid duplicates
  socket.off(SocketChannels.nofitification);

  // Set up notification listener
  socket.on(SocketChannels.nofitification, (payload) => {
    store.dispatch(PUSH_NOTIFICATION_POPUP_ACTION, payload);
  });

  // Join rooms if account is available
  joinRooms();

  // re-attach notification listener on reconnect; socket.ts rejoinAll handles rooms
  socket.on("connect", () => {
    socket.off(SocketChannels.nofitification);
    socket.on(SocketChannels.nofitification, (payload) => {
      store.dispatch(PUSH_NOTIFICATION_POPUP_ACTION, payload);
    });
  });

  if (socket.connected) {
    const checkAndJoinRooms = () => {
      const account = store.state.account?.account?.data;
      if (account?.id || account?.organizationId) {
        joinRooms();
      }
    };

    setTimeout(checkAndJoinRooms, 100);
    setTimeout(checkAndJoinRooms, 500);
  }

  store.commit(SOCKET_BOUND);
}
